import { GetServerSideProps } from 'next'
import { useTranslation } from 'hooks/useTranslation'
import Head from 'next/head'
import React from 'react'
import { Login } from 'features/Login/Login'
import { withGuestAccess } from 'utils/withAuthorization'

export const getServerSideProps: GetServerSideProps = withGuestAccess

export default function LoginPage(props: any) {
  const { t } = useTranslation()

  return (
    <div>
      <Head>
        <title>{t('login:login')}</title>
        <meta name="title" content={t('login:meta-title')} />
        <meta name="description" content={t('login:meta-description')} />
      </Head>

      <main>
        <Login forward={props.forward} />
      </main>
    </div>
  )
}
